// extracted by mini-css-extract-plugin
export default {"title":"NotFoundPage_title__MmoKO","image_not_found":"NotFoundPage_image_not_found__XAymJ"};